import React from 'react'

import { Text } from '@plurall/elo-beta'

import styles from './FormError.module.scss'

interface IFormErrorMessage {
  error: string
  className?: string
}
const FormErrorMessage = ({ error, className }: IFormErrorMessage) => (
  <div className={className || styles.formError}>
    <Text size='t3' variant='negative'>
      {error}
    </Text>
  </div>
)

export default FormErrorMessage
